import React, { useState, useMemo, useEffect } from "react";
import { Search, FileText, X } from "lucide-react";
import "./ConsolidateCollectionReport.css";
import { FaFilter, FaUser } from "react-icons/fa";
import { userServicer } from "../../Commen_Services/user.services";
import { Chip, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { GrPowerReset } from "react-icons/gr";
import { IoClose } from "react-icons/io5";
import Popup from "reactjs-popup";
import { RoleRightMasterService } from "../../Commen_Services/RoleRightMaster.service";
import { AccessLevel, InputType } from "../../../_enums/enum.services";
import ExportToCSV from "../../Commen_Component/Export/ExportToCSV";
import { commanServicer } from "../../Commen_Services/common.services";

interface ColumnData {
    tableFieldName: string;
    headerName: string;
    subReportKeyField: string;
    showfieldDDL: boolean;
    fieldType: Number;
    isDisplay: boolean;
    isExport: boolean;

}

interface FilterChip {
    id: string;
    label: string;
    value: string;
    removable: boolean;
}

interface SortConfig {
    field: string;
    direction: 'asc' | 'desc';
}

interface SearchCriteria {
    id: string;
    field: string;
    value: string;
}

interface TransactionReport {
    subReportName: string;
    collectionDate: string;
    paymentMode: string;
    collectedAmount: string;
    details: any[];
}


export default function ConsolidateCollectionReport() {
    const [data, setData] = useState<any[]>([]);
    const [columnData, setColumnData] = useState<ColumnData[]>([]);
    const [reportConfigData, setreportConfigData] = useState<any>([]);
    const [isDefaultSearch, setIsDefaultSearch] = useState<boolean>(false);
    const [viewButtonSum, setButtonSum] = useState<number[]>([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [searchField, setSearchField] = useState("");
    const [searchTerm, setSearchTerm] = useState<Record<string, string>>({});
    const [sortConfig, setSortConfig] = useState<SortConfig | null>(null);
    const [searchCriteria, setSearchCriteria] = useState<SearchCriteria[]>([]);
    const [dynamicFilterValues, setDynamicFilterValues] = useState<Record<string, string>>({});
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [previousFrom, setPreviousFrom] = useState(dateFrom);
    const [previousTo, setPreviousTo] = useState(dateTo);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showTransactionReport, setShowTransactionReport] = useState(false);
    const [subReportLoading, setSubReportLoading] = useState(true);
    const [selectedTransactionReport, setSelectedTransactionReport] = useState<TransactionReport | null>(null);
    const [selectedTransactionColumns, setSelectedTransactionColumns] = useState<ColumnData[]>([]);
    const [exportColumns, setExportColumns] = React.useState<ColumnData[]>(columnData);
    const [activeFilters, setActiveFilters] = useState<FilterChip[]>([
        {
            id: "dateFrom",
            label: "Collection Date From",
            value: dateFrom,
            removable: false
        },
        {
            id: "dateTo",
            label: "Collection Date To",
            value: dateTo,
            removable: false
        }
    ]);
    const [errors, setErrors] = useState<any>({});
    const [firstLoadData, setFirstloadData] = useState<any>({});

    useEffect(() => {
        fecthReportData();
    }, []);

    useEffect(() => {
        if(dateFrom != "" && dateTo != "")
        {
            fetchData();
        }
    },[isDefaultSearch]);

    const fecthReportData = async () => {
        try {
            const [tableConfig, reportConfig, roleRightAccessSum] = await Promise.all([
                userServicer.tableConfig(22),
                userServicer.reportConfig(22),
                RoleRightMasterService.getRoleRigthAccessSum(22)
            ]);
            const exportColumnData = tableConfig?.data?.filter((item: any) => item.isExport === true);
            setColumnData(tableConfig.data);
            setreportConfigData(reportConfig.data);
            setButtonSum(findSumElements(roleRightAccessSum.data[0].accessLevel));
            setExportColumns(exportColumnData);
            let def = reportConfig.data.defaultSearchList;
            if (def?.length > 0) {
                def.forEach((element: any) => {
                    if (element.hasFromToDateField == 1) {
                        if (element.defaultSearchFieldValue != null && element.defaultSearchFieldValue != undefined) {
                            const currentDate = new Date(element.defaultSearchFieldValue);
                            currentDate.setDate(currentDate.getDate() + element.defDateDurationInDays);
                            const nextDate = currentDate.toISOString().split('T')[0];
                            const today = new Date().toISOString().split('T')[0];
                            setDateFrom(element.defaultSearchFieldValue);
                            setDateTo(nextDate > today ? today : nextDate);
                            setFirstloadData((prev: any) => ({ ...prev, ["dateFrom"]: element.defaultSearchFieldValue, ["dateTo"] : nextDate > today ? today : nextDate})); 
                        } else {
                            const toDate = new Date().toISOString().split('T')[0];
                            const lastDate = new Date(toDate);
                            lastDate.setDate(lastDate.getDate() - element.defDateDurationInDays);
                            const fromDate = lastDate.toISOString().split('T')[0];
                            setDateFrom(fromDate);
                            setDateTo(toDate);
                            setFirstloadData((prev: any) => ({ ...prev, ["dateFrom"]: fromDate, ["dateTo"] : toDate})); 

                        }
                    }
                });
                setIsDefaultSearch(true);
            }
            else {

            }
        }
        catch (ex) {

        }
    }

    const findSumElements = (target: number): number[] => {
        //const arr = [1, 2, 4, 8, 16, 32, 64, 128];
        const arr = Object.values(AccessLevel);
        let result: number[] = [];
        let n = arr.length;

        // Use a variable to keep track of whether a valid subset is found
        let found = false;

        // Loop through all possible subsets using bitmasking
        for (let i = 0; i < (1 << n); i++) {
            let sum = 0;
            let subset: number[] = [];

            for (let j = 0; j < n; j++) {
                if (i & (1 << j)) {
                    sum += arr[j];
                    subset.push(arr[j]);
                }
            }

            // Check if the current subset sums up to the target
            if (sum === target) {
                // Update result only if a subset is found
                result = subset;
                found = true;
                break;  // Exit the loop once a valid subset is found
            }
        }

        // Return the result if found, otherwise an empty array
        return found ? result : [];
    };

    const fetchData = async (resetFilters = false) => {
        try {
            setTableLoading(true);
            setLoadingProgress(0);
            if (resetFilters) {
                setSearchCriteria([]);
                setSearchField("");
                setCurrentPage(1);
                setSortConfig(null);

                // Reset active filters to only date filters
                setActiveFilters([
                    {
                        id: "dateFrom",
                        label: "Collection Date From",
                        value: dateFrom,
                        removable: false
                    },
                    {
                        id: "dateTo",
                        label: "Collection Date To",
                        value: dateTo,
                        removable: false
                    }
                ]);
            }
            const progressSteps = [10, 25, 45, 60, 75, 85, 95];
            let i = 0;
            const progressInterval = setInterval(() => {
                if (i < progressSteps.length) {
                    setLoadingProgress(progressSteps[i]);
                    i++;
                }
            }, 200);
            const tableData = await userServicer.getConsolidateReport(dateFrom, dateTo);
            clearInterval(progressInterval);
            setLoadingProgress(100);
            setData(tableData.data);
        } catch (ex) {
            console.error("Failed to fetch data", ex);
        } finally {
            setTimeout(() => {
                setTableLoading(false);
                setLoadingProgress(0);
            }, 300);
        }
    };

    // Update date filter chips when dates change
    useEffect(() => {
        setActiveFilters(prev => prev.map(filter => {
            if (filter.id === "dateFrom") {
                return { ...filter, value: dateFrom };
            } else if (filter.id === "dateTo") {
                return { ...filter, value: dateTo };
            }
            return filter;
        }));
    }, [dateFrom, dateTo]);

    // Enhanced search filtering
    const filteredData = useMemo(() => {
        if (!data?.length) return [];

        return data.filter((item) => {
            return Object.entries(searchTerm).every(([field, term]) => {
                if (!term) return true;

                const value = item[field];
                return value?.toString().toLowerCase().includes(term.toLowerCase());
            });
        });
    }, [data, searchTerm]);

    const filteredAndSortedData = useMemo(() => {
        if (!data.length) return [];
        // First, filter the data
        const filtered = data.filter(item => {
            // If no search criteria, return all data
            if (searchCriteria.length === 0) return true;
            // Check all saved search criteria (must ALL match - AND logic)
            const matchesAllCriteria = searchCriteria.every(criteria => {
                if (!criteria.value) return true;
                let matches = false;
                if (criteria.field === "") {
                    // Global search across all fields
                    matches = Object.values(item).some(value =>
                        value?.toString().toLowerCase().includes(criteria.value.toLowerCase())
                    );
                } else {
                    // Field-specific search
                    const fieldValue = item[criteria.field ];
                    matches = fieldValue?.toString().toLowerCase().includes(criteria.value.toLowerCase()) || false;
                }
                return matches;
            });
            return matchesAllCriteria;
        });
        if (sortConfig) {
            filtered.sort((a, b) => {
                const aValue = (a[sortConfig.field] ?? '') as string | number;
                const bValue = (b[sortConfig.field] ?? '') as string | number;

                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return filtered;
    }, [data, searchCriteria, sortConfig]);

    useEffect(() => {
        const values = searchCriteria.reduce<Record<string, string>>((acc, item) => {
            acc[item.field] = item.value;
            return acc;
        }, {});
        setDynamicFilterValues(values);
    }, [searchCriteria]);

    const totalPages = Math.ceil(filteredAndSortedData.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const currentData = filteredAndSortedData.slice(startIndex, endIndex);

    // Reset to first page when search changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, searchField]);

    const handleApplyFilters = () => {
        if (dateFrom > dateTo) {
            setErrors((prevErrors: any) => ({ ...prevErrors, ["dateFrom"]: 'Please enter a valid date' }));
            setErrors((prevErrors: any) => ({ ...prevErrors, ["dateTo"]: 'Please enter a valid date' }));
        }
        else {
            setErrors((prevErrors: any) => ({ ...prevErrors, ["dateFrom"]: '' }));
            setErrors((prevErrors: any) => ({ ...prevErrors, ["dateTo"]: '' }));
            const newFilters: FilterChip[] = [
                {
                    id: "dateFrom",
                    label: "Collection Date From",
                    value: dateFrom,
                    removable: false
                },
                {
                    id: "dateTo",
                    label: "Collection Date To",
                    value: dateTo,
                    removable: false
                }
            ];
            activeFilters.map((item) => {
                if (item.id === "dateFrom" && item.value != previousFrom) {
                    fetchData();
                    setPreviousFrom(dateFrom);
                }
            })
            const newData: FilterChip[] = Object.entries(dynamicFilterValues).map(([field, value]) => {
                const label = columnData.find(col => col.tableFieldName === field)?.headerName || field;

                return {
                    id: `${field}`,
                    label,
                    value,
                    removable: true
                };
            });
            newFilters.push(...newData);
            setActiveFilters(newFilters);

            const isDifferent =
                Object.keys(dynamicFilterValues).some(
                    key => searchTerm[key] !== dynamicFilterValues[key]
                ) ||
                Object.keys(searchTerm).some(
                    key => !(key in dynamicFilterValues)
                );

            if (isDifferent) {
                setSearchTerm(dynamicFilterValues);
            }

            const newSearchCriteria: SearchCriteria[] = Object.entries(dynamicFilterValues).map(
                ([field, value]) => ({
                    id: `${field}`,
                    field,
                    value
                })
            );
            const hasChanges = newSearchCriteria.length !== searchCriteria.length ||
                newSearchCriteria.some((item, index) =>
                    item.field !== searchCriteria[index]?.field ||
                    item.value !== searchCriteria[index]?.value
                );
            if (hasChanges) {
                setSearchCriteria(newSearchCriteria);
            }
            setShowFilterPopup(false);
        }
    };

    const removeFilter = (filterId: string) => {
        setActiveFilters(prev => {
            const updated = prev.filter(filter => filter.id !== filterId);
            return updated;
        });

        setSearchCriteria(prev => {
            const updated = prev.filter(criteria => criteria.id !== filterId);
            return updated;
        });
        console.log(searchTerm);
        setSearchTerm(prev => {
            const updated = { ...prev };
            delete updated[filterId];
            return updated;
        });

        if (filterId === "search") {
            setSearchField("");
        }
    };

    const handleSubReportClick = async (data: any, subReportKey: string) => {
        setShowTransactionReport(true);
        setSubReportLoading(true);

        switch (subReportKey) {
            case "1":
                const appTableConfig = await userServicer.tableConfig(23);
                setSelectedTransactionColumns(appTableConfig.data);
                break;
            case "2":
                const odooTableConfig = await userServicer.tableConfig(26);
                setSelectedTransactionColumns(odooTableConfig.data);
                break;
            case "3":
                const easebuzzTableConfig = await userServicer.tableConfig(24);
                setSelectedTransactionColumns(easebuzzTableConfig.data);
                break;
            case "4":
                const cashTableConfig = await userServicer.tableConfig(25);
                setSelectedTransactionColumns(cashTableConfig.data);
                break;
            default:
                break;
        }
        const { controller: newController, data: transactionData } = await userServicer.getConsolidateReportDetail(data, subReportKey);

        const subReportData = getSubReportDataBySubReportKey(data, subReportKey);
        const totalCollectedAmount = transactionData?.data?.reduce((sum: any, item: any) => {
            return sum + (item.collectedAmount ?? 0);
        }, 0);
        const tempTransactionData: TransactionReport = {
            subReportName: subReportData.reportName,
            collectionDate: data?.date,
            paymentMode: data?.modeOfPayment,
            collectedAmount: totalCollectedAmount,
            details: transactionData?.data
        }
        setSelectedTransactionReport(tempTransactionData);
        setSubReportLoading(false);
    };

    function getSubReportDataBySubReportKey(
        row: Record<string, any>,
        subReportKey: string
    ): { amount: any; reportName: string } {
        if (!row || typeof row !== 'object') {
            return { amount: 0, reportName: 'Unknown' };
        }
        switch (subReportKey) {
            case '1':
                return { amount: row.appTransactionAmount ?? 0, reportName: 'App Transaction Report' };
            case '2':
                return { amount: row.odooTransactionAmount ?? 0, reportName: 'Odoo Transaction Report' };
            case '3':
                return { amount: row.easebuzzTransactionAmount ?? 0, reportName: 'Easebuzz Transaction Report' };
            case '4':
                return { amount: row.approvedCashAmount ?? 0, reportName: 'Approved Cash Transaction Report' };
            default:
                return { amount: 0, reportName: 'Unknown' };
        }
    }

    const handleSort = (fieldName: string) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig && sortConfig.field === fieldName && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ field: fieldName, direction });
    };

    const addSearchCriteria = (value: string | null | undefined) => {
        if (!searchField) return;
        const isEmpty = value === "" || value === null || value === undefined;
        setSearchCriteria(prevCriteria => {
            let updatedCriteria: SearchCriteria[];

            if (isEmpty) {
                // Remove the search field from criteria
                updatedCriteria = prevCriteria.filter(
                    criteria => criteria.field !== searchField
                );
            } else {
                const existingIndex = prevCriteria.findIndex(
                    criteria => criteria.field === searchField
                );

                if (existingIndex !== -1) {
                    updatedCriteria = [...prevCriteria];
                    updatedCriteria[existingIndex] = {
                        ...updatedCriteria[existingIndex],
                        value: value
                    };
                } else {
                    const newCriteria: SearchCriteria = {
                        id: searchField,
                        field: searchField,
                        value: value
                    };
                    updatedCriteria = [...prevCriteria, newCriteria];
                }
            }

            // Update active filters
            setActiveFilters(prevFilters => {
                const fieldLabel = searchField === "" ? "Global Search" :
                    columnData.find(col => col.tableFieldName === searchField)?.headerName || searchField;

                if (isEmpty) {
                    return prevFilters.filter(filter => filter.label !== fieldLabel);
                }

                const existingFilterIndex = prevFilters.findIndex(filter =>
                    filter.label === fieldLabel
                );

                const newFilter: FilterChip = {
                    id: searchField,
                    label: fieldLabel,
                    value: value,
                    removable: true
                };

                let updatedFilters: FilterChip[];

                if (existingFilterIndex !== -1) {
                    updatedFilters = [...prevFilters];
                    updatedFilters[existingFilterIndex] = newFilter;
                } else {
                    updatedFilters = [...prevFilters, newFilter];
                }

                return updatedFilters;
            });

            return updatedCriteria;
        });
    };

    const handleDynamicFilterChange = (fieldName: string, value: string) => {
        setDynamicFilterValues(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const resetDynamicFilters = () => {
        setDynamicFilterValues({});
        setDateFrom(firstLoadData?.dateFrom);
        setDateTo(firstLoadData?.dateTo);
        setErrors({});
    };

    const closeSubReport = () => {
        setShowTransactionReport(false);
        setSelectedTransactionReport(null);
        setSelectedTransactionColumns([]);
    }

    return (
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;{reportConfigData.reportName}
                    </span>
                </div>
                <hr className="colorgraph" />
            </div>

            <div className="mani">
                <div style={{ width: '100%' }}>
                    <div>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="popup_filter1" >
                                <div className="popup_filter2">
                                    <FormControl variant="standard">
                                        <InputLabel id="demo-simple-select-standard-label" sx={{
                                            fontSize: '12px', color: 'var(--body-main-dark-color)', borderColor: 'var(--body-main-dark-color)',
                                        }}> Search Field </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={searchField}
                                            onChange={(e) => setSearchField(e.target.value)}
                                            label="Search Field"
                                            MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 140,
                                                        overflowY: 'auto',
                                                    },
                                                },
                                            }}
                                        >
                                            {columnData.map((option, i) => (
                                                option.fieldType != InputType.Date && <MenuItem key={i} value={option.tableFieldName}>{option.headerName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <div style={{ marginTop: '3px' }}>
                                        {
                                            <FormControl variant="standard">
                                                <TextField
                                                    variant="standard"
                                                    value={searchTerm[searchField] || ""}
                                                    label="search"
                                                    onChange={(e) => { setSearchTerm((prev) => ({ ...prev, [searchField]: e.target.value })); addSearchCriteria(e.target.value) }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: 'var(--body-main-dark-color)',
                                                            fontSize: '12px',
                                                            borderColor: 'red',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            width: '200px',
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        }

                                    </div>
                                    <div className="center-pop">
                                        {

                                            viewButtonSum.map((item: any, btnIndex) => (
                                                <React.Fragment key={`${btnIndex}-${'btn'}`}>
                                                    {item === AccessLevel.Filter && (<button key={`${btnIndex}`} className="btn12" onClick={() => setShowFilterPopup(true)}><FaFilter /></button>)}
                                                    {item === AccessLevel.Export && (<ExportToCSV csvData={filteredAndSortedData} headerName={exportColumns} fileName={reportConfigData?.exportReportName} pageID={"22"} filterFieldData={[]} TotalRecord={0} isStatic={true} />)}
                                                </React.Fragment>
                                            ))

                                        }
                                    </div>
                                </div>
                                <div className="chips-container">
                                    <Stack
                                        spacing={{ xs: 1, sm: 1 }}
                                        direction="row"
                                        useFlexGap
                                        sx={{ flexWrap: 'wrap' }}
                                        alignItems="flex-end"
                                        justifyContent="flex-end"
                                    >
                                        {activeFilters.map((filter) => (
                                            <Chip
                                                key={filter.id}
                                                label={`${filter.label} : ${filter.value}`}
                                                variant="outlined"
                                                onDelete={filter.removable ? () => removeFilter(filter.id) : undefined}
                                                sx={{
                                                    backgroundColor: '#d3eafc',
                                                    border: '1px solid var(--body-main-dark-color)',
                                                    color: 'var(--body-main-dark-color)',
                                                    fontWeight: 500,
                                                    width: 'fit-content',
                                                }}
                                            />
                                        ))}
                                    </Stack>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="card-container">
                <div className="collection-wrapper">
                    {/* Table */}
                    <div className="collection-table-card">
                        <div className="collection-table-wrapper">
                            <table className="collection-table">
                                <thead className="collection-table-header">
                                    <tr className="collection-table-header-row">
                                        {columnData.map((column) => (
                                            <th
                                                key={column.tableFieldName}
                                                className="collection-table-header-cell"
                                                onClick={() => handleSort(column.tableFieldName)}
                                                style={{
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    position: 'relative',
                                                    paddingRight: '2rem'
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>{column.headerName}</span>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        marginLeft: '0.5rem',
                                                        fontSize: '0.75rem',
                                                        lineHeight: '1'
                                                    }}>
                                                        <span style={{
                                                            color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === 'asc'
                                                                ? 'var(--body-main-dark-color)' : 'rgba(255, 255, 255, 0.5)',
                                                            fontSize: '0.525rem'
                                                        }}>▲</span>
                                                        <span style={{
                                                            color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === 'desc'
                                                                ? 'var(--body-main-dark-color)' : 'rgba(255, 255, 255, 0.5)',
                                                            fontSize: '0.525rem'
                                                        }}>▼</span>
                                                    </div>
                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="collection-table-body">
                                    {tableLoading ? (
                                        <tr>
                                            <td
                                                colSpan={columnData.length}
                                                className="collection-loading-container"
                                            >
                                                <div className="collection-loading-content">
                                                    <div className="collection-loading-spinner">
                                                        <div className="collection-loading-spinner-inner">
                                                            <FileText />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h3 className="collection-loading-title">Loading Table Data</h3>
                                                        <p className="collection-loading-text">Processing hard report data...</p>
                                                        <div className="collection-progress-bar">
                                                            <div
                                                                className="collection-progress-fill"
                                                                style={{ width: `${loadingProgress}%` }}
                                                            ></div>
                                                        </div>
                                                        <p className="collection-progress-text">{loadingProgress}%</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : currentData.map((row, index) => (
                                        <tr
                                            key={row.id}
                                            className="collection-table-row"
                                            style={{ animationDelay: `${index * 50}ms` }}
                                        >
                                            {columnData.map((column) => (
                                                <td
                                                    key={column.tableFieldName}
                                                    className="collection-table-cell"
                                                >
                                                    {column.subReportKeyField != "" ? (
                                                        <button
                                                            disabled={Number(row[column.tableFieldName]) == 0}
                                                            onClick={() => handleSubReportClick(row, column.subReportKeyField)}
                                                            className="collection-customer-link"
                                                        >
                                                            {row[column.tableFieldName]}
                                                        </button>
                                                    ) : column.fieldType === InputType.Date ? (commanServicer.formatToCustomDateTime(row[column.tableFieldName], false)) : (
                                                        row[column.tableFieldName]
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    {currentData.length === 0 && !tableLoading && (
                                        <tr>
                                            <td
                                                colSpan={columnData.length}
                                                className="collection-empty-state"
                                            >
                                                <div className="collection-empty-content">
                                                    <Search />
                                                    <p className="collection-empty-title">No results found</p>
                                                    <p className="collection-empty-text">Try adjusting your search criteria</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="collection-pagination">
                            <div className="collection-pagination-content">
                                <div className="collection-pagination-left">
                                    <span className="collection-pagination-text">Rows per page:</span>
                                    <FormControl variant="standard" sx={{ m: 1, border: 'none' }}>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={rowsPerPage}
                                            onChange={(e) => {
                                                setRowsPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            disableUnderline
                                            sx={{
                                                border: 'none'
                                            }}
                                        >
                                            <MenuItem value={5}>5</MenuItem>
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <span className="collection-pagination-text">
                                        {filteredData.length === 0 ? "0" : startIndex + 1}-{Math.min(endIndex, filteredData.length)} of {filteredData.length}
                                    </span>
                                </div>

                                <div className="collection-pagination-right">
                                    <button
                                        onClick={() => setCurrentPage(1)}
                                        disabled={currentPage === 1}
                                        className="collection-pagination-btn"
                                    >
                                        <FirstPageIcon />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                        disabled={currentPage === 1}
                                        className="collection-pagination-nav-btn"
                                    >
                                        <KeyboardArrowLeft />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        className="collection-pagination-nav-btn"
                                    >
                                        <KeyboardArrowRight />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(totalPages)}
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        className="collection-pagination-btn"
                                    >
                                        <LastPageIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showFilterPopup && (
                        <Popup contentStyle={{ height: 250, width: 450, padding: 0 }} open={showFilterPopup} onClose={() => setShowFilterPopup(false)}>
                            <div className="pop-main">
                                <div className="pop-head"><span className="pop-form">&nbsp;<FaFilter />&nbsp;&nbsp;Consolidate Collection Summary Filter</span></div>
                                <div className="pop-form">
                                    <div className="grid-container">
                                        {columnData
                                            .filter(column => column.showfieldDDL || column.fieldType === InputType.Date || column.fieldType === InputType.Text)
                                            .map((column) => (
                                                <>
                                                    {column.fieldType === InputType.Date ? (
                                                        <>
                                                            <TextField
                                                                sx={{ marginRight: 1 }}
                                                                id="standard-basic"
                                                                variant="standard"
                                                                name={column.tableFieldName + "_from"}
                                                                type="date"
                                                                value={dateFrom}
                                                                label={column.headerName + " From "}
                                                                onChange={(e) => { setPreviousFrom(dateFrom); setDateFrom(e.target.value) }}
                                                                // onChange={(event) => { handleChangeforChips({ key: column.headerName + " from", value: event.target.value }); handleChangeforFromDate(event, field.tableFieldName); }}
                                                                // onChange={(event) => { handleChangeforChips({ key: field.headerName + " from", value: event.target.value });handleChangeforChips({ key: field.headerName + " To ", value: dateInputs[field.tableFieldName+"_to"] ? (event.target.value != "" ? dateInputs[field.tableFieldName+"_to"] : "" ) : event.target.value != "" ? " " : ""}); handleChangeforFromDate(event,field.tableFieldName);}}
                                                                error={!!errors["dateFrom"]}
                                                                helperText={errors["dateTo"]}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        className: dateFrom ? '' : 'custom-date-input',
                                                                        max: "9999-12-31",
                                                                    },
                                                                    style: {
                                                                        color: dateFrom ? '#243C5C' : 'black',
                                                                        fontSize: '14px',
                                                                        width: '200px',

                                                                    },
                                                                    // onInput: (event: any) => {

                                                                    //     const value = event.target.value;
                                                                    //     if (value == "") {
                                                                    //         setInputs((values: any) => ({ ...values, [event.target.name]: event.target.value }))
                                                                    //     }
                                                                    // }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '12px',
                                                                        // borderColor: errors[field.tableFieldName + "_from"] ? 'red' : undefined,
                                                                    },

                                                                }}
                                                                FormHelperTextProps={{
                                                                    style: {
                                                                        fontSize: errors["dateFrom"] ? '9px' : '12px',
                                                                        maxWidth: '210px'

                                                                    },
                                                                }}

                                                            />
                                                            <TextField
                                                                sx={{ marginRight: 1 }}
                                                                id="standard-basic"
                                                                variant="standard"
                                                                name={column.tableFieldName + "_to"}
                                                                type="date"
                                                                value={dateTo}
                                                                // value={((typeof dateInputs[field.tableFieldName + "_to"]) == "string") ? dateInputs[field.tableFieldName + "_to"] : startDate}
                                                                label={column.headerName + " To "}
                                                                onChange={(e) => { setPreviousTo(dateTo); setDateTo(e.target.value) }}
                                                                // onChange={(event) => { handleChangeforChips({ key: field.headerName + " To ", value: event.target.value }); handleChangeforToDate(event, field.tableFieldName); }}
                                                                //onChange={(event) => { dateInputs[field.tableFieldName+"_from"] && handleChangeforChips({ key: field.headerName + " To ", value: event.target.value != "" ? event.target.value : " " }); handleChangeforToDate(event, field.tableFieldName);}}
                                                                error={!!errors["dateTo"]}
                                                                helperText={errors["dateTo"]}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        className: dateTo ? '' : 'custom-date-input',
                                                                        max: "2030-12-31",
                                                                    },
                                                                    style: {
                                                                        color: dateTo ? '#243C5C' : 'black',
                                                                        fontSize: '14px',
                                                                        width: '200px',
                                                                        // borderColor: errors[field.tableFieldName + "_to"] ? 'red' : undefined,

                                                                    },
                                                                    // onInput: (event: any) => {

                                                                    //     const value = event.target.value;
                                                                    //     if (value == "") {
                                                                    //         setInputs((values: any) => ({ ...values, [event.target.name]: event.target.value }))
                                                                    //         // setDateInputs((prev) => ({
                                                                    //         //     ...prev,
                                                                    //         //     [field.tableFieldName+"_to"]: event.target.value,
                                                                    //         // }));
                                                                    //     }
                                                                    // }
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '12px',
                                                                        // borderColor: errors[field.tableFieldName + "_to"] ? 'red' : undefined,


                                                                    },

                                                                }}
                                                                FormHelperTextProps={{
                                                                    style: {
                                                                        fontSize: errors["dateTo"] ? '9px' : '12px',
                                                                        maxWidth: '210px'

                                                                    },
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <div>
                                                            <TextField id="standard-basic" key={`${column.tableFieldName}-${column.headerName}`} variant="standard" name={column.tableFieldName} value={dynamicFilterValues[column.tableFieldName] || ''} label={column.headerName}
                                                                //onChange={handleChange}
                                                                onChange={(e) => handleDynamicFilterChange(column.tableFieldName, e.target.value)}

                                                                InputProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '14px',
                                                                        width: '200px',
                                                                        borderColor: 'red'
                                                                    }

                                                                }}

                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: '#243C5C',
                                                                        fontSize: '12px',
                                                                        borderColor: 'red',

                                                                    },
                                                                }}

                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ))}
                                    </div>
                                    <div className='btns'>
                                        <div>
                                            <button className='btn1' onClick={resetDynamicFilters} ><span><GrPowerReset /></span>Reset</button>
                                        </div>
                                        <div>
                                            <button className='btn1' onClick={handleApplyFilters}><span><FaFilter /></span> Filter</button>&nbsp;
                                            <button className='btn1' onClick={() => setShowFilterPopup(false)} ><span><IoClose /></span>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    )
                }
                {showTransactionReport && (
                    <div className="collection-modal-overlay">
                        <div className="transaction-report-modal">
                            {/* Header */}
                            <div className="shadow">
                                <div className="bg-line">
                                    <span className="bg-head"><FaUser /> &nbsp;{selectedTransactionReport?.subReportName}
                                    </span>
                                </div>
                                <hr className="colorgraph" />
                            </div>

                            {/* Summary Info */}
                            <div className="transaction-report-summary">
                                <div className="transaction-summary-grid">
                                    <div className="summary-item">
                                        <label className="summary-label">Collection Date</label>
                                        <span className="summary-value">{commanServicer.formatToCustomDateTime((selectedTransactionReport?.collectionDate as string), false)}</span>
                                    </div>
                                    <div className="summary-item">
                                        <label className="summary-label">Payment Mode</label>
                                        <span className="summary-value">{selectedTransactionReport?.paymentMode}</span>
                                    </div>
                                    <div className="summary-item">
                                        <label className="summary-label">Collected Amount</label>
                                        <span className="summary-value collected-amount">{selectedTransactionReport?.collectedAmount}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Collection Details Section */}
                            <div className="transaction-report-body" >
                                <div className="collection-details">
                                    <h3 className="collection-details-title">Collection Details:</h3>
                                    {
                                        viewButtonSum.filter((item) => item === AccessLevel.Export).map((item) =>
                                                            (<div style={{margin: '0 0 0.5rem 0'}}><ExportToCSV   csvData={(selectedTransactionReport?.details as any[])} 
                                            headerName={selectedTransactionColumns?.filter((item) => item.isExport === true)}
                                            fileName={(selectedTransactionReport?.subReportName as string)}
                                            pageID={"22"} filterFieldData={[]}
                                            TotalRecord={0}
                                            isStatic={true} /></div>))
                                    }
                                </div>
                                <div className="transaction-table-wrapper">
                                    <ReusableTable columnData={selectedTransactionColumns?.filter((item) => item.isDisplay === true)} currentData={selectedTransactionReport?.details} loading={subReportLoading} />
                                </div>
                                <div className="transaction-report-footer">
                                    <button
                                        onClick={() => closeSubReport()}
                                        className="transaction-close-btn"
                                    >
                                        <X height={18} />
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}

interface TableProps<T> {
    columnData: ColumnData[];
    currentData: T[] | undefined;
    onSort?: (field: string) => void;
    onRowClick?: (row: T, keyField?: string) => void;
    rowKey?: (row: T, index: number) => string | number;
    loading?: boolean;
}

export function ReusableTable<T extends Record<string, any>>({
    columnData,
    currentData,
    onSort,
    onRowClick,
    rowKey,
    loading
}: TableProps<T>) {
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState<{ field: string; direction: 'asc' | 'desc' } | null>(null);


    const sortedData = React.useMemo(() => {
        if (!Array.isArray(currentData)) return [];
        if (!sortConfig) return currentData;

        return [...currentData].sort((a, b) => {
            const aValue = a[sortConfig.field];
            const bValue = b[sortConfig.field];

            if (aValue == null) return 1;
            if (bValue == null) return -1;

            if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
            return 0;
        });
    }, [currentData, sortConfig]);

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = currentPage * rowsPerPage;
    const paginatedData = sortedData?.slice(startIndex, endIndex) || [];
    const totalPages = Math.ceil(sortedData?.length / rowsPerPage);

    useEffect(() => {
        if (loading) {
            const interval = setInterval(() => {
                setLoadingProgress((prev) => (prev < 100 ? prev + 10 : 100));
            }, 200);
            return () => clearInterval(interval);
        }
    }, [loading]);

    const handleSort = (field: string) => {
        setSortConfig(prev => {
            if (prev?.field === field) {
                return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            } else {
                return { field, direction: 'asc' };
            }
        });
    };



    return (
        <div className="collection-table-card">
            <div className="collection-table-wrapper" style={{ maxHeight: '30vh' }}>
                <table className="collection-table">
                    <thead className="collection-table-header">
                        <tr className="collection-table-header-row">
                            {columnData.map((column) => (
                                <th
                                    key={column.tableFieldName}
                                    className="collection-table-header-cell"
                                    onClick={() => handleSort(column.tableFieldName)}
                                    style={{ cursor: "pointer", userSelect: "none", position: "relative", paddingRight: "2rem" }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <span>{column.headerName}</span>
                                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "0.5rem", fontSize: "0.75rem", lineHeight: "1" }}>
                                            <span style={{ color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === "asc" ? "var(--body-main-dark-color)" : "rgba(255, 255, 255, 0.5)", fontSize: "0.525rem" }}>▲</span>
                                            <span style={{ color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === "desc" ? "var(--body-main-dark-color)" : "rgba(255, 255, 255, 0.5)", fontSize: "0.525rem" }}>▼</span>
                                        </div>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="collection-table-body">
                        {loading ? (
                            <tr>
                                <td colSpan={columnData.length} className="collection-loading-container">
                                    <div className="collection-loading-content">
                                        <div className="collection-loading-spinner">
                                            <div className="collection-loading-spinner-inner">
                                                <FileText />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : paginatedData?.length > 0 ? (
                            paginatedData?.map((row, index) => (
                                <tr
                                    key={rowKey ? rowKey(row, index) : index}
                                    className="collection-table-row"
                                    style={{ animationDelay: `${index * 50}ms` }}
                                >
                                    {columnData.map((column) => (
                                        <td
                                            key={column.tableFieldName}
                                            className="collection-table-cell"
                                        >
                                            {column.fieldType === InputType.Date
                                                ?
                                                (commanServicer.formatToCustomDateTime(row[column.tableFieldName], false))
                                                :
                                                (column.fieldType === InputType.DateTime ? (commanServicer.formatToCustomDateTime(row[column.tableFieldName], true))
                                                    :
                                                    (row[column.tableFieldName]))
                                            }
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columnData.length} className="collection-empty-state">
                                    <div className="collection-empty-content">
                                        <Search />
                                        <p className="collection-empty-title">No results found</p>
                                        <p className="collection-empty-text">Try adjusting your search criteria</p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="collection-pagination">
                <div className="collection-pagination-content">
                    <div className="collection-pagination-left">
                        <span className="collection-pagination-text">Rows per page:</span>
                        <FormControl variant="standard" sx={{ m: 1, border: "none" }}>
                            <Select
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                disableUnderline
                                sx={{ border: "none" }}
                            >
                                {[5, 10, 25].map((val) => (
                                    <MenuItem key={val} value={val}>{val}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <span className="collection-pagination-text">
                            {sortedData.length === 0 ? "0" : startIndex + 1}-{Math.min(endIndex, sortedData.length)} of {sortedData.length}
                        </span>
                    </div>

                    <div className="collection-pagination-right">
                        <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} className="collection-pagination-btn">
                            <FirstPageIcon />
                        </button>
                        <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1} className="collection-pagination-nav-btn">
                            <KeyboardArrowLeft />
                        </button>
                        <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages || totalPages === 0} className="collection-pagination-nav-btn">
                            <KeyboardArrowRight />
                        </button>
                        <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages || totalPages === 0} className="collection-pagination-btn">
                            <LastPageIcon />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

